// ============================================================================
// CHANGO V5.0 — 404 NotFound landing
// ============================================================================
// Shared across all 4 SPA entries (site / public / app / ops). The "home"
// link therefore can't hard-code a tenant path like /dashboard — that used
// to 404 on the marketing host and the ops host. Task #55: accept a
// `homeHref` prop and default to "/" (which resolves correctly in every
// bundle: site /, public /s/..., app /login, ops /ops/login via the
// BrowserRouter root Navigate).
// ============================================================================

import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NotFound({ homeHref = '/', homeLabel = '回到首页' }) {
  const location = useLocation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="card max-w-md p-8 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-500">
          <span className="text-xl font-bold" aria-hidden="true">?</span>
        </div>
        <h1 className="text-xl font-semibold text-slate-800">页面未找到</h1>
        <p className="mt-3 text-sm text-slate-600">
          路径 <code className="rounded bg-slate-100 px-1 py-0.5 text-xs">{location.pathname}</code> 不存在。
        </p>
        <div className="mt-6 flex justify-center gap-3 text-sm">
          <Link to={homeHref} className="btn-primary">{homeLabel}</Link>
        </div>
      </div>
    </div>
  );
}
